document.addEventListener('DOMContentLoaded', () => {
    subscribe(PUB_SUB_EVENTS.cartUpdate, (data) => {
        // console.log(`Cart updated from source: ${data.source}`);

        if (data.parentSku) {
            fetch(`/apps/errea/products/${data.parentSku}/inventories`, {
                method: 'GET',
            });

            fetch(`/apps/errea/products/${data.parentSku}/update-shopify-inventories`, {
                method: 'PUT',
            });
        }
    });
})
